import { createUseStyles } from "react-jss";

export default createUseStyles({
    container: {
        position: "relative",
    },
    statementsContainer: {
        display: "flex",
        overflowX: "hidden",
        scrollBehavior: "smooth",
        width: "100%",
        margin: "0 auto",
        justifyContent: "center",
    },
    statement: {
        width: ({ isMobileView, contentResponsivenessOption }) =>
            !isMobileView
                ? "460px"
                : contentResponsivenessOption === "resize-carousel"
                ? "100%"
                : "293px",
        height: ({ isMobileView, contentResponsivenessOption }) =>
            isMobileView && contentResponsivenessOption !== "resize-carousel"
                ? "293px"
                : contentResponsivenessOption === "resize-carousel"
                ? "auto"
                : "460px",
        backgroundColor: ({ color }) => color,
        color: "#555555",
        textAlign: "center",
        minWidth: ({ isMobileView }) => (isMobileView ? "100%" : ""),
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: ({ justifyContent }) => justifyContent,
        borderRadius: "12px",

        "& .statementTextContent": {
            padding: "15px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },

        "& .statementTextContent:empty": {
            display: "none",
        },

        "& .image-wrapper": {
            display: "flex",
            justifyContent: "center",
            width: "100%",
        },

        "& .crop-image": {
            width: ({ isMobileView }) => (isMobileView ? "293px" : "460px"),
            height: ({ isMobileView }) => (isMobileView ? "246px" : "387px"),
            minWidth: "100%",
            minHeight: "100%",
            maxWidth: "none",
            maxHeight: "none",
            objectFit: "cover",
            objectPosition: "center center",
        },
    },
    navigationButtonsPanel: {
        textAlign: "center",
        display: "flex",
        justifyContent: ({ justifyContent }) => justifyContent,
        marginTop: "25px",

        "& .fixedWidth": {
            flex: "0 0 20px",
            minWidth: "20px",
        },
    },
    navigationButton: {
        height: "100%",
        cursor: "pointer",
    },
});
